import { Stack } from "@mui/material";
import { Text } from "@src/lib/ui-react";

export function HyperTrackEmbeddedView({
  trackingUrl,
  ...style
}: { trackingUrl?: string } & React.CSSProperties) {
  if (!trackingUrl) {
    return (
      <Stack direction="row" justifyContent="center" alignItems="center">
        <Text variant="h2">Live tracking view is not available</Text>
      </Stack>
    );
  }

  const url = new URL(trackingUrl);
  url.searchParams.set("start_stage_text", "Worker is on the way to the shift");
  url.searchParams.set("enroute_stage_text", "Worker is on the way or has arrived");
  url.searchParams.set("complete_stage_text", "Shift has completed");
  url.searchParams.set("map_only", "true");
  url.searchParams.set("hide_controls", "true");

  return (
    // eslint-disable-next-line react/iframe-missing-sandbox
    <iframe
      title="HyperTrack Live Worker ETA"
      src={url.toString()}
      style={{
        width: "100%",
        border: "none",
        ...style,
      }}
    />
  );
}
